import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CadastroAnexoIModal from '../../pages/Contratos/Fluxos/FluxoCentralizados/ContratoEntePrivadoEdit/CadastroAnexoIModal';
import { changeContratoEntePrivadoEditingValue } from '../../store/modules/ContratosEntePrivadoActions';
import { openModal } from '../../store/modules/ModalActions';
import { getElementID, getMergedClassNames } from '../../utils/HTMLUtils';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import DeleteForeverIcon from '../Icons/DeleteForeverIcon';
import EditIcon from '../Icons/EditIcon';
import styles from './PlanoTrabalhoItem.scss';

const rootClassName = styles.rootClassName;

class PlanoTrabalhoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      planoTrabalhoList: this.props.contratosEntePrivado.contratoEditing
        .planoTrabalho
        ? this.props.contratosEntePrivado.contratoEditing.planoTrabalho
        : [],
    };
  }

  allowEditButton() {
    return true;
  }

  openEdicaoPlanoTrabalho = () => {
    this.props.openModal(CadastroAnexoIModal, {
      planoTrabalho: this.props.planoTrabalho,
      savedCallback: this.props.changePlanoTrabalho,
    });
  };

  toRemove = () => {
    this.props.changePlanoTrabalho(null, this.props.planoTrabalho.index);
  };

  confirmRemoverPlanoTrabalho = () => {
    this.props.openModal(ConfirmModal, {
      title: this.props.languageValues.confirmDeletePlanoTrabalhoModalTitle,
      /* eslint-disable-next-line */
      content: this.props.languageValues.confirmDeletePlanoTrabalho,
      confirmLabel: this.props.languageValues.removerProjetoModalConfirmLabel,
      confirmCallback: () => this.toRemove(),
    });
  };

  render() {
    return (
      <TableRow
        cols={[12, 12, 6, 6, 6]}
        id={getElementID(this.props.id, 'row')}
        className={rootClassName + '-plano-trabalho-row'}
        index={this.props.planoTrabalho.index}
      >
        {this.allowEditButton() ? (
          <TableCell className={rootClassName + '-cell'}>
            <button
              type={'button'}
              className={rootClassName + '-table-action-button'}
              onClick={this.openEdicaoPlanoTrabalho}
              disabled={this.props.fieldDisabled()}
            >
              <EditIcon className={rootClassName + '-table-action-icon'} />
            </button>
          </TableCell>
        ) : null}
        <TableCell
          onClick={
            !this.props.fieldDisabled() ? this.openEdicaoPlanoTrabalho : null
          }
          className={getMergedClassNames([
            rootClassName + '-cell ',
            !this.props.fieldDisabled() ? rootClassName + '-link-cell' : '',
          ])}
        >
          {this.props.planoTrabalho.nomeLinhaOrcamentaria}
        </TableCell>
        <TableCell
          onClick={
            !this.props.fieldDisabled() ? this.openEdicaoPlanoTrabalho : null
          }
          className={getMergedClassNames([
            rootClassName + '-cell ',
            !this.props.fieldDisabled() ? rootClassName + '-link-cell' : '',
          ])}
        >
          {this.props.planoTrabalho.oque}
        </TableCell>
        <TableCell
          onClick={
            !this.props.fieldDisabled() ? this.openEdicaoPlanoTrabalho : null
          }
          className={getMergedClassNames([
            rootClassName + '-cell ',
            !this.props.fieldDisabled() ? rootClassName + '-link-cell' : '',
          ])}
        >
          {this.props.planoTrabalho.quando}
        </TableCell>
        <TableCell className={rootClassName + '-cell'}>
          <button
            type={'button'}
            onClick={this.confirmRemoverPlanoTrabalho}
            className={rootClassName + '-table-action-button'}
            disabled={this.props.fieldDisabled()}
          >
            <DeleteForeverIcon
              className={rootClassName + '-table-action-icon'}
            />
          </button>
        </TableCell>
      </TableRow>
    );
  }
}

PlanoTrabalhoItem.propTypes = {
  fieldDisabled: PropTypes.func.isRequired,
  planoTrabalho: PropTypes.object.isRequired,
  changePlanoTrabalho: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratosEntePrivado: state.contratosEntePrivado,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoEntePrivadoEditingValue,
      openModal,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PlanoTrabalhoItem));
